<div class="flex w-full flex-col mt-28 bg-lGray850">
  <nav class="bg-lGray850 px-4 py-8 md:px-8 md:py-16">
    <div class="mx-28 grid max-w-full grid-cols-1 items-start gap-8 md:grid-cols-[auto_1fr] md:gap-44 lg:mx-44">
      <div class="flex items-center">
        <img
          src="assets/images/unico-logo.svg"
          alt="Unico"
          class="h-auto w-40 max-w-full"
        />
      </div>

      <div class="flex flex-col gap-4">
        <h3 class="m-0 text-lg font-semibold text-lWhite md:text-xl">Navegação</h3>
        <ul class="m-0 flex list-none flex-col gap-2 p-0 md:gap-3">
          <li *ngFor="let link of navLinks">
            <a
              [routerLink]="link.route"
              class="text-base text-lSecondary no-underline transition-colors duration-300 hover:text-lPrimary focus:text-lPrimary focus:outline-none"
            >
              {{ link.label }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>

  <div class="bg-gradient-to-b from-lPurple600 to-[#4A3AFF] px-4 py-4 md:px-8 md:py-4">
    <div class="mr-28 flex max-w-screen flex-wrap items-center justify-center gap-4 md:justify-end">
      <p class="m-0 basis-full text-center text-sm font-medium text-white md:basis-auto md:text-base md:text-left">
        Desenvolvido por
      </p>
      <div class="flex items-center">
        <img
          src="assets/images/liga-logo.svg"
          alt="LIGA"
          class="block h-auto w-28 max-w-full drop-shadow-[0_2px_4px_rgba(0,0,0,0.1)]"
        />
      </div>
      <span class="select-none text-xs font-medium text-white/80" title="Versão do sistema">{{ appVersion }}</span>
    </div>
  </div>
</div>
